interface HTTPErrorObject {
  error: HttpErrorResponse;
}

interface HttpErrorResponse {
  status?: number;
  statusCode?: number;
  errorMessage?: string;
}

function isActualResponse(response) {
  return response && typeof response === 'object' && (response.status || response.statusCode);
}

export function errorHandler(response) {
  const res: HTTPErrorObject = {
    error: {},
  };

  if (isActualResponse(response)) {
    res.error.status = response.status || response.statusCode;
    const serverErrorMsg = response.data ? response.data : null;

    if (res.error.status === 401) {
      res.error.errorMessage = 'Your session is expired, please re-login again';
    } else if (res.error.status === 400) {
      res.error.errorMessage = serverErrorMsg || 'Some thing is not right with the request';
    } else if (res.error.status === 403) {
      res.error.errorMessage =
        serverErrorMsg || "User doesn't have permission to perform this action";
    } else if (res.error.status === 502) {
      res.error.errorMessage = 'Server unavailable, please try after some time';
    } else if (res.error.status === 404) {
      res.error.errorMessage = serverErrorMsg || 'Not found';
    } else {
      res.error.errorMessage = serverErrorMsg || 'Something went wrong, please try again';
    }
  }

  return res;
}

export default errorHandler;
